import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal. Pass an array of strings (each a line).
 */
export const KineticHeading = ({ lines, className = "", delay = 0.15, highlightIndex }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="reveal-line-wrap">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: delay + i * 0.11, ease: [0.22, 1, 0.36, 1] }}
        >
          {highlightIndex === i ? (
            <span className="text-amber-500">{line}</span>
          ) : (
            line
          )}
        </motion.span>
      </span>
    ))}
  </span>
);
